import { Platform } from 'react-native';

/**
 * Send a GTM event safely on Web (and log on Native)
 */
export const sendGTMEvent = (eventName: string, params: Record<string, any> = {}) => {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    const dataLayer = (window as any).dataLayer || [];
    dataLayer.push({
      event: eventName,
      ...params,
    });
  } else {
    // Placeholder for Native log
    if (__DEV__) {
      console.log(`[GTM] Event fired (Native): ${eventName}`, params);
    }
  }
};

/**
 * Inject GTM Script into the document head/body (Web only)
 */
export const injectGTMScript = () => {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    // GTM Head Script
    const scriptId = 'gtm-script';
    if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5T4VP689');`;
        document.head.appendChild(script);
    }

    // GTM Body NoScript
    const noscriptId = 'gtm-noscript';
    if (!document.getElementById(noscriptId)) {
        const noscript = document.createElement('noscript');
        noscript.id = noscriptId;
        const iframe = document.createElement('iframe');
        iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-5T4VP689";
        iframe.height = "0";
        iframe.width = "0";
        iframe.style.display = "none";
        iframe.style.visibility = "hidden";
        noscript.appendChild(iframe);
        document.body.prepend(noscript);
    }
  }
};
